import { useState } from 'react'
import styled from 'styled-components'
import { Button, ButtonBase } from '@mui/material'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import { Drawer } from '../../components'
import { useTranslation } from "react-i18next"

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
`

const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  border: 2px solid #d6d7db;
  border-radius: 8px;
  padding: 18px 12px;
`

const OrdinatorDrawer = ({ open, onClose, onOrderSave }) => {
  const { t } = useTranslation('common')
  const initialState = [
    { name: t('ordenation.working'), value: 'working' },
    { name: t('ordenation.high_fatigue'), value: 'high_fatigue' },
    { name: t('ordenation.sleep'), value: 'sleep' },
    { name: t('ordenation.prediction'), value: 'prediction' },
  ]
  const [order, setOrder] = useState(initialState)

  const onSave = () => {
    onOrderSave({ order })
    onClose()
  }

  const onReset = () => setOrder(initialState)

  const moveItem = (index, direction) => {
    const newIndex = index + direction

    if (newIndex < 0 || newIndex >= order.length) return

    const newItems = [...order]
    ;[newItems[index], newItems[newIndex]] = [
      newItems[newIndex],
      newItems[index],
    ]
    setOrder(newItems)
  }

  return (
    <Drawer
      title={t('ordenation.button')}
      open={open}
      onClose={onClose}
    >
      <Drawer.Body>
        <OptionsContainer>
          {order.map(({ name, value }, index) => (
            <OptionContainer key={value}>
              <span>{name}</span>
              <div>
                {index !== 0 && (
                  <ButtonBase>
                    <ArrowUpwardIcon
                      onClick={() => moveItem(index, -1)}
                      sx={{ color: '#757575' }}
                    />
                  </ButtonBase>
                )}
                {index + 1 !== order.length && (
                  <ButtonBase>
                    <ArrowDownwardIcon
                      onClick={() => moveItem(index, 1)}
                      sx={{ color: '#757575' }}
                    />
                  </ButtonBase>
                )}
              </div>
            </OptionContainer>
          ))}
        </OptionsContainer>
      </Drawer.Body>
      <Drawer.Actions>
        <Button onClick={onReset}>{t('restore')}</Button>
        <Button
          onClick={onSave}
          variant='contained'
        >
          {t('save')}
        </Button>
      </Drawer.Actions>
    </Drawer>
  )
}

export default OrdinatorDrawer
